// coded by DevaVishnu (https://dvrepo.com)

document.getElementById('order-note-form').addEventListener('submit', function(event) {
  event.preventDefault(); // Prevent the form from being submitted

  // Get the order note from the form
  var orderNote = document.getElementById('CartSpecialInstructions').value;

  // Save the order note using an AJAX request
  var xhr = new XMLHttpRequest();
  xhr.open('POST', '/cart/update.js');
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.onload = function() {
    if (xhr.status === 200) {
      console.log('saved successfully');
      document.getElementById("bt-sidebar-cart").classList.remove("is--contentUpdate");
      document.getElementById("t4s-mini_cart-tool__content").classList.remove("is--opend");
    } else {
      // There was an error saving the order note
      console.log('error')
    }
  };
  xhr.send('note=' + encodeURIComponent(orderNote));
});

